module.exports = __webpack_public_path__ + "static/media/today-i-asked.dc817eea.png";